import { ArrowUpRight } from 'lucide-react';
import { FadeIn, ChapterHeading } from './Reveal';
import { useLang } from '../i18n/LangContext';

export const WhoFor = () => {
  const { t } = useLang();
  const WHO_CARDS = t.who.cards;
  return (
  <section data-testid="who-for-section" className="bg-krug-deep py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <ChapterHeading number="09" eyebrow={t.who.eyebrow} title={t.who.title} />
      <div className="mt-14 grid md:grid-cols-3 gap-5 md:gap-6">
        {WHO_CARDS.map((card, i) => (
          <FadeIn key={card.title} delay={i * 0.1}>
            <a
              href="#waitlist"
              data-testid={`who-card-${i}`}
              className="group flex h-full flex-col justify-between rounded-3xl glass-dark p-9 md:p-11 hover:border-krug-gold/50 hover:-translate-y-1.5 transition-[border-color,transform] duration-500"
            >
              <div>
                <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-krug-gold/12 text-krug-goldbright">
                  <card.icon size={26} />
                </span>
                <h3 className="mt-7 font-heading text-2xl md:text-[1.7rem] font-extrabold text-white">{card.title}</h3>
                <p className="mt-3.5 text-base text-slate-400 leading-relaxed">{card.copy}</p>
              </div>
              <span className="mt-9 inline-flex items-center gap-1.5 text-sm font-bold text-krug-tealbright group-hover:text-krug-goldbright transition-colors duration-300">
                {t.who.linkLabel}
                <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </a>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
  );
};
